export const FILE_TYPE_NOT_SUPPORTED_ERROR = "File type is not supported";
export const UNSUPPORTED_DOC_TYPE_ERROR = "Document type is not supported";
export const EXTRACTION_FAILED_ERROR = "Unable to extract data from file";

export const getBannerTitle = (errorMessage: string | null): string => {
  if (
    errorMessage === FILE_TYPE_NOT_SUPPORTED_ERROR ||
    errorMessage === UNSUPPORTED_DOC_TYPE_ERROR
  ) {
    return "Please upload an acceptable identification document.";
  }
  return "";
};

export const getFileCardError = (errorMessage: string | null): string => {
  if (
    errorMessage === FILE_TYPE_NOT_SUPPORTED_ERROR ||
    errorMessage === UNSUPPORTED_DOC_TYPE_ERROR
  ) {
    return "File type is not supported";
  }
  if (errorMessage === EXTRACTION_FAILED_ERROR) {
    return "Unable to extract data from file.";
  }
  return "";
};
